export { default } from './Renegociacao25FinBanner';
